import {
    usePortalCommunicationService,
    useSentry
} from './hooks';

export const AppServices = () => {
    usePortalCommunicationService();
    useSentry();

    return null;
};
